module.exports = __webpack_public_path__ + "img/python.2dce35e2.png";